(function () {

  const product_slider_v1_list = document.querySelectorAll('.js_product_slider_v1')

  for (let i = 0; i < product_slider_v1_list.length; i++) {
    const slider = product_slider_v1_list[i]
    initProductSliderV1(slider)

    breakTitle(slider);

  }

  function initProductSliderV1(slider) {
    const sliderWrapEl = slider.closest('.product-slider-sec')
    const swiperPagination = sliderWrapEl.querySelector('.swiper-pagination')
    const swiperButtonNext = sliderWrapEl.querySelector('.swiper-button-next')
    const swiperButtonPrev = sliderWrapEl.querySelector('.swiper-button-prev')

    let sliderOptions = {
      spaceBetween: 40,
      slidesPerView: 1,
      centeredSlides: true,
      noSwipingClass: 'slide-card__action-link',
      watchSlidesProgress: true,
      loop: true,
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 768px
        767: {
          slidesPerView: 2,
          centeredSlides: false,
          spaceBetween: 40
        },
        // when window width is >= 1200px
        1200: {
          centeredSlides: false,
          slidesPerView: 3,
          spaceBetween: 60
        }
      },
      pagination: {
        el: swiperPagination,
        clickable: true,
        dynamicBullets: false,
      },
      navigation: {
        nextEl: swiperButtonNext,
        prevEl: swiperButtonPrev,
      },
    }

    new Swiper(slider, sliderOptions)
  }

  function breakTitle(slider) {
    const sliderItems = slider.querySelectorAll(".slide-card__title");

    sliderItems.forEach(item => {
      const originalHtml = item.innerHTML;
      const firstWord = originalHtml.replace(/^\s+/, '').split(' ')[0];
      const remainingContent = originalHtml.slice(firstWord.length + 1);
      item.innerHTML = `${firstWord}</br>${remainingContent}`;
    });
  }

})()
